import { useCallback } from 'react';

import { usePerformanceActions } from 'src/store';

export const useHandlers = (channel, setAccountSearchText) => {
  const performanceActions = usePerformanceActions();

  const handleAccountSearchChange = useCallback(
    (value) => {
      setAccountSearchText(value);
    },
    [setAccountSearchText]
  );

  const handleSortChange = useCallback(
    (field) => {
      performanceActions.sortAccounts(field, channel);
    },
    [performanceActions, channel]
  );

  return { handleAccountSearchChange, handleSortChange };
};
